import { initI18n, getLocaleCookie, setLocaleCookie } from './i18n'

function initLocale () {
  const language = navigator.language || navigator.userLanguage
  let locale = getLocaleCookie()

  if (!locale) {
    if (language) {
      if (language.indexOf('ko') > -1) {
        locale = 'ko'
      } else if (language.indexOf('ja') > -1) {
        locale = 'ja'
      } else {
        locale = 'en'
      }
    } else {
      locale = 'en'
    }
    setLocaleCookie(locale)
  }

  document.documentElement.setAttribute('lang', locale)
  return locale
}

function loadWebFonts (locale) {
  return new Promise((resolve, reject) => {
    let webfont = 'https://fonts.googleapis.com/css?family=Roboto'
    switch (locale) {
      case 'ko':
        webfont += '%7CNoto+Sans+KR'
        break
      case 'ja':
        webfont += '%7CNoto+Sans+JP'
        break
    }

    let link = document.createElement('link')
    link.setAttribute('rel', 'stylesheet')
    link.setAttribute('href', webfont)
    link.setAttribute('media', 'all')
    link.setAttribute('crossorigin', 'anonymous')

    let head = document.getElementsByTagName('head')[0]
    if (!head) {
      head = document.documentElement
    }
    head.insertBefore(link, head.lastChild)

    resolve()
  })
}

export default function () {
  const locale = initLocale()
  try {
    return initI18n(locale)
  } catch (err) {
    console.error(err)
  }
}
